import React from 'react';
import _ from 'lodash';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import { pl } from 'date-fns/locale';
import { useClickOutside } from '../../services/hooks';
import { CssTextField } from '../others/CssTextField';
import { TextField } from '@mui/material';

export const SmallFormDateField = props => {
  const { name, value, id, onChange, helperText, sx, label, variant, standardTextField, disabled, views, inputFormat = 'dd.MM.yyyy', mask = '__.__.____' } = props;
  const wrapperRef = React.useRef(null);
  const clickOutside = useClickOutside(wrapperRef);
  const [open, setOpen] = React.useState(false);
  const [error, setError] = React.useState(false);

  const handleChange = val => {
    if (!val) {
      return;
    }
    if (isNaN(val.valueOf())) {
      setError(true);

      return;
    }
    setError(false);
    onChange(val);
  };

  const handleClose = () => {
    if (clickOutside) {
      setOpen(false);
    }
  };
  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={pl} >
      <DatePicker
        disabled={disabled}
        ref={wrapperRef}
        id={id}
        inputFormat={inputFormat}
        views={views}
        onClose={handleClose}
        mask={mask}
        open={open}
        name={name}
        value={value}
        onChange={val => handleChange(val)}
        label={label}
        sx={{ borderColor: 'red' }}
        renderInput={props => {
          props.error = error;
          props.helperText = helperText;
          if (standardTextField) {
            return (
              <TextField
                disabled={disabled}
                error={error}
                helperText={helperText}
                onClick={handleOpen}
                variant={variant || 'outlined'}
                sx={{ width: '60%', borderColor: 'red', maxWidth: '1200px', ...sx }}
                // size="small"
                {...props} />
            );
          }

          return (
            <CssTextField
              disabled={disabled}
              error={error}
              helperText={helperText}
              onClick={handleOpen}
              variant={variant || 'outlined'}
              sx={{ width: '60%', ...sx, borderColor: 'red', maxWidth: '1200px' }}
              size="small"
              {...props} />
          );

        }}
        KeyboardButtonProps={{
          'aria-label': 'change date'
        }}
        PopperProps={{
          style: { zIndex: 35001 }
        }}
      />

    </LocalizationProvider>
  );
};
